import React, { useContext } from "react";
import ConfiguratorContext from "./ConfiguratorContext";
import ConfiguratorSurveyAlert from "./ConfiguratorSurveyAlert";
import ConfiguratorSurveyOutput from "./ConfiguratorSurveyOutput";
import ConfiguratorSurveyQuestion from "./ConfiguratorSurveyQuestion";

const ConfiguratorSurveyBlockRender = ({
  onChange,
  block,
  hideOutput,
  recursiveResponses,
  recursiveResponsesIndex,
  realtime,
  role,
  summary,
  saveResponses
}) => {
  const { survey, responses } = useContext(ConfiguratorContext);

  let activeResponses = recursiveResponses || responses;

  switch (block.type) {
    case "alert":
      return <ConfiguratorSurveyAlert key={block.id} alert={block} role={role} saveResponses={saveResponses} />;

    case "question":
      return (
        <ConfiguratorSurveyQuestion
          onChange={onChange}
          responses={activeResponses}
          value={activeResponses[block.id]?.value}
          key={block.id}
          question={block}
          role={role}
          disabled={survey?.closed ?? false}
        />
      );
    case "output":
      if (hideOutput) {
        // console.log(hideOutput, block);
        return null;
      }
      return (
        <ConfiguratorSurveyOutput
          key={block.id}
          output={block}
          responses={activeResponses}
          recursiveResponsesIndex={recursiveResponsesIndex}
          realtime={realtime}
          role={role}
          isInRecursiveOutput={Object.values(recursiveResponses ?? {}).length > 0}
          summary={summary}
        />
      );

    default:
      return null;
  }
};

export default ConfiguratorSurveyBlockRender;
